export const displayTimingGroupTranslationJP = {
  DisplayTimingGroup: {
    head_title: '表示タイミング設定（一覧）',
    add_head_title: '表示タイミング設定（新規作成）',
    detail_head_title: '表示タイミング設定（編集）',
    copy_head_title: '表示タイミング設定（コピー）',

    group_name: 'グループ名',
    note: '説明',
    search: '絞り込み',
    status: '状態',
    selection: '選択',
    display_order: '表示順',
    order_change: '順位変更',
    week_range: '曜日',
    date_range: '日程',
    time_range: '時間帯',
    target_menu: '対象メニュー',
    target_menu_setting: '対象メニュー設定',
    condition: '適用条件',

    add_new: '新規追加',
    detail: '修正',
    copy: 'コピー',
    delete: '削除',
    save: '保存',

    week_control: '曜日制御',
    date_control: '日程制御',
    time_control: '時間帯制御',

    period_control: 'A. 期間指定',
    monthly_day_control: 'B. 毎月・特定日指定',
    monthly_day_select_placeholder: '選択無し',
    date_control_note: '※A・Bは単独または併用可。併用時はAND条件で判定します。',

    given_time_none: '指定なし（全時間帯で表示）',
    given_time_lunch: 'ランチ時間帯',
    given_time_range: '時間指定（30分単位）',
    extend_time: '猶予時間',
    given_time_control_note:
      '※ 時間指定では開始－OPEN／終了－CLOSEを選択可。終了後も猶予時間内はカート投入済みメニューの注文送信が可能（デフォルト10分）。',

    overlay_display: 'オーバーレイ表示',
    overlay_display_label: '表示する — 条件外もオーバーレイで表示し、注文不可を案内する',
    overlay_display_note1: '※ チェックしない場合は「非表示」（条件外はメニュー自体を表示しない）',
    overlay_display_note2: '※ メニュー詳細の「非表示」オプションで、メニュー毎の設定も可能です。',
    overlay_message_label: '表示コメント',
    overlay_message_label_default: '(デフォルト)',

    include: 'のみ表示',
    exclude: '以外表示',

    legend_title: '凡例（表示条件の見方）',
    legend_weekday_sample: '月火水木金',
    legend_holiday_sample: '土日祝',
    legend_no_background: '背景色なし',
    legend_has_background: '背景色あり',

    confirm_delete: '選択された表示タイミング設定を削除します。<br>よろしいですか？',
    confirm_delete_not_allowed:
      '<p>選択された表示タイミング設定のうち<strong>（{{group_names}}）</strong>は、対象メニューが存在しているため削除できません。</p>',
    confirm_delete_condition:
      '<p>選択された表示タイミング設定のうち<strong>（{{group_names}}）</strong>は、対象メニューが存在しているため削除できません。対象メニューを削除してから表示タイミング設定を削除してください。それ以外の選択された表示タイミング設定を削除します。<br>よろしいですか？</p>',
    confirm_copy: 'グループ「{{name}}」をコピーしますか？',
    confirm_delete_group:
      'このグループには{{menu_count}}つのターゲットメニューが関連付けられているため、削除できません。',
    confirm_overlay_enabled:
      '設定を変更する場合、登録されている対象メニューの「非表示オプション」が全て変更されます。<br>よろしいですか？',

    warn_field_required: 'この項目は必須です',
    warn_max_length: '{{max}}文字以内で入力してください',
    warn_monthly_days_required: '1つ以上選択してください',
    warn_given_range_start_required: '開始時刻を入力してください',
    warn_given_range_end_required: '終了時刻を入力してください',
    warn_given_range_order: '終了時刻は開始時刻以降を指定してください',
    warn_period_start_required: '開始日を入力してください',
    warn_period_end_required: '終了日を入力してください',
    warn_period_order: '終了日は開始日以降を指定してください',

    target_menu_modal: {
      head_title: '対象メニュー画面',
      group_label: '表示タイミンググループ：{{name}}',
      menu_count: '関連メニュー数：{{count}}件',

      add_label: '新規に追加',
      add_to_group: '＋ グループへ追加',
      selected_label: '{{count}}件選択中（選択した行に対する操作）',
      remove_from_group: 'グループから外す',
      no_selection: '選択無し',
      move_to_group: 'グループへ移す',

      selection: '選択',
      menu_code: 'メニューコード',
      menu_name: 'メニュー名',

      confirm_remove: '対象メニューをリストから削除します。よろしいですか？',
    },
  },
};
